export default __webpack_public_path__ + "static/media/Vfb.b2004835.png";